// The page a sign-in mail's button opens when the link is the Mac app's: one
// asked for in the app (Poulpe-816), or by `dev/serve signin-link app`. The
// server sends `/open#poulpe%3A%2F%2Fsignin%2F<attempt>%23<token>`, the app's
// link percent-encoded, so a mail tracker's redirect meets no second `#`;
// older mails carry it as it is, `/open#poulpe-next-dev://signin/<attempt>#<token>`.
// Mail readers make no link of an app's own address, and some refuse it even
// in HTML, so the mail links here, on the server's own web address, and this
// page hands the link on to the app. It reads nothing from the server and
// signs nobody in: the app finishes the link with the verifier it kept when
// it asked for it. The link stays in the fragment, which no request carries,
// and leaves the address once read.
import { useEffect, useRef, useState } from 'react'
import { BoardLogo, BoardWordmark } from '../components/Icons'
import { openAppWords as w } from './words'

/**
 * The app's sign-in link the fragment holds, or null for anything else: one
 * of Poulpe's own schemes (as the handoff allows them), its `signin` path,
 * an attempt, and a token after `#`, both in base64url; as it is, or
 * percent-encoded.
 */
export function appLinkOf(hash: string): string | null {
  const given = hash.startsWith('#') ? hash.slice(1) : hash
  const shape = /^poulpe(-[a-z0-9]+){0,3}:\/\/signin\/[A-Za-z0-9_-]{1,128}#[A-Za-z0-9_-]{1,128}$/
  if (shape.test(given)) return given
  let decoded: string
  try {
    decoded = decodeURIComponent(given)
  } catch {
    return null
  }
  return shape.test(decoded) ? decoded : null
}

export function OpenAppPage({ hash, go }: { hash: string; go: (link: string) => void }) {
  const [link] = useState(() => appLinkOf(hash))
  // Once, even where an effect runs twice (StrictMode in development).
  const handed = useRef(false)
  useEffect(() => {
    // Out of the address bar and the history, now that it is read.
    window.history.replaceState(null, '', window.location.pathname)
    if (link && !handed.current) {
      handed.current = true
      go(link)
    }
  }, [link, go])
  return (
    <div className="app">
      <header className="app-header">
        <span className="brand" aria-label="Poulpe">
          <BoardLogo size={20} />
          <span className="brand-name">
            <BoardWordmark height={18} />
          </span>
        </span>
      </header>
      <main className="app-main">
        <div className="sign-in-page">
          <section className="sign-in-card" aria-labelledby="open-app-title">
            <h1 id="open-app-title">{link ? w.opening : w.notALink}</h1>
            {link ? (
              <>
                <p className="sign-in-line">{w.ifNothing}</p>
                <p>
                  <a className="button button-primary" href={link}>
                    {w.open}
                  </a>
                </p>
                <p className="muted">{w.close}</p>
              </>
            ) : (
              <p className="sign-in-line">{w.askAgain}</p>
            )}
          </section>
        </div>
      </main>
    </div>
  )
}
